import React from 'react';
import { useTranslation } from 'react-i18next';

import { useStyles } from './SubscriptionPlans.styles';
import theme from '../../../styles/theme';
import FlexibleColumnsTable from '../../../components/reusable/Table/FlexibleColumnsTable';
import { useSubscriptionPlansComponent } from './useSubscriptionPlansComponent';
import ConfirmDialog from '../../../components/reusable/confirm-dialog/ConfirmDialog';
import Search from '../../../components/reusable/search/Search';
import AppDialog from '../../../components/reusable/app-dialog/AppDialog';
import AddSubscriptionPlan from './add-subscription-plan/AddSubscriptionPlan';
import { Box } from '@mui/material';
import AppButton from '../../../components/designe/app-button/AppButton';
import { useAccess } from '../../../hooks/useAccess';
import { SubscriptionPlansFilter } from './SubscriptionPlansFilter';

const SubscriptionPlans = (props) => {
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const {
    sortedArray,
    columnsList,
    order,
    orderBy,
    cellReducers,
    onSort,
    onSortColumns,
    itemForDelete,
    setItemForDelete,
    onItemDelete,
    filter,
    setFilter,
    showEditModal,
    setShowEditModal,
    itemForEditing,
    setItemForEditing,
    filterFormik,
    filterScopeOptions,
    filterPeriodOptions,
  } = useSubscriptionPlansComponent(classes);
  const { access } = useAccess();

  return (
    <div className={classes.wrapper}>
      <SubscriptionPlansFilter
        formik={filterFormik}
        filterScopeOptions={filterScopeOptions}
        filterPeriodOptions={filterPeriodOptions}
      />
      <Box display="flex" gap={1} alignItems="center" marginBottom={2}>
        <Search fullWidth value={filter} onChange={setFilter} />
        {access?.subscriptionPlans?.canCreate && (
          <AppButton onClick={() => setShowEditModal(true)}>
            {t('common.add')}
          </AppButton>
        )}
      </Box>
      <FlexibleColumnsTable
        data={sortedArray}
        columnsList={columnsList}
        order={order}
        orderBy={orderBy}
        onSort={onSort}
        classes={classes}
        onSortColumns={onSortColumns}
        cellReducers={cellReducers}
        onSelectAllRows={() => {}}
        stickyHeader={true}
      />
      <ConfirmDialog
        open={!!itemForDelete}
        onClose={() => setItemForDelete(null)}
        title={t('common.delete')}
        onSubmit={() => onItemDelete()}>
        {t('common.deleteQuestion')}
      </ConfirmDialog>

      <AppDialog
        open={!!showEditModal}
        onClose={() => {
          setShowEditModal(false);
          setItemForEditing(null);
        }}
        title={
          itemForEditing
            ? t('superAdminDashboard.editSubscriptionPlan')
            : t('superAdminDashboard.addSubscriptionPlan')
        }>
        <AddSubscriptionPlan
          subscriptionPlan={itemForEditing}
          onClose={() => {
            setShowEditModal(false);
            setItemForEditing(null);
          }}
        />
      </AppDialog>
    </div>
  );
};

export default SubscriptionPlans;
